var headers = document.querySelectorAll('.collapsible-row__header');

for (var i = 0; i < headers.length; i++) {
    headers[i].addEventListener('click', function () {
		// Find the parent .collapsible-row (replacement for closest())
		var row = this;
		while (row && row.nodeType === 1 && (!row.classList || !row.classList.contains('collapsible-row'))) {
			row = row.parentNode;
		}
		if (!row) return;

		var wrapper = row.querySelector('.collapsible-row__content--wrapper');
		var content  = row.querySelector('.collapsible-row__content');
		if (!wrapper || !content) return;

		var isOpen = row.classList.contains('is-open');

		if (isOpen) {
			// Close: set current height then animate to 0
			wrapper.style.height = wrapper.scrollHeight + 'px';
			setTimeout(function () {
				wrapper.style.height = '0px';
			}, 0);
			row.classList.remove('is-open');
		} else {
			// Open: set height to content height
			wrapper.style.height = content.scrollHeight + 'px';
			row.classList.add('is-open');
		}
    });
}

window.addEventListener('load', function() {
  	gsap.registerPlugin(ScrollTrigger);

	const wrapper = document.querySelector(".infographic-pane-wrapper");
	const layout  = wrapper.querySelector(".robotic-intro");

	if (wrapper && layout) {
		ScrollTrigger.matchMedia({
			"(min-width: 992px)": function () {
				gsap.set(layout, { width: "100%" });

				gsap.to(layout, {
					width: "50%",
					ease: "none",
					scrollTrigger: {
						trigger: wrapper,
						start: "top top",
						end: function () {
							return "+=" + Math.round(window.innerHeight * 0.9);
						},
						scrub: 0.5,
						pin: wrapper,
						pinSpacing: true,
						anticipatePin: 1,
						invalidateOnRefresh: true
					}
				});
			},

			// Mobile/tablet (< 992px)
			"(max-width: 991px)": function () {
				gsap.set(layout, { clearProps: "width" });
			}
		});
	}

	/**
	 * Nav/Images active states
	 */
	(function () {
		var panels = Array.prototype.slice.call(document.querySelectorAll('[id^="panel-"]'));
		var dots = Array.prototype.slice.call(document.querySelectorAll('.graphic-panel__nav-dot[data-panel-target]'));
		var images = Array.prototype.slice.call(document.querySelectorAll('[id^="image-"]'));

		var ctaEl = document.getElementById("graphic-panel-cta");
		var navEls = Array.prototype.slice.call(document.querySelectorAll("#graphic-panel-nav, #graphic-panel-nav-mobile"));
		var mobileNavWrapper = document.querySelector(".graphic-panel__nav--wrapper");

		if (!panels.length) return;

		function clearActiveDots() {
			dots.forEach(function (dot) {
				dot.classList.remove("active");
			});
		}

		function clearCompletedDots() {
			dots.forEach(function (dot) {
				dot.classList.remove("is-complete");
			});
		}

		function clearActiveImages() {
			images.forEach(function (image) {
				image.classList.remove("active");
			});
		}

		function setActiveDotsBySuffix(suffix) {
			clearActiveDots();

			dots.forEach(function (dot) {
				if (dot.getAttribute("data-panel-target") === suffix) {
					dot.classList.add("active");
				}
			});
		}

		function setCompletedDotsBeforeSuffix(suffix) {
			var activePanelNumber = parseInt(suffix, 10);

			dots.forEach(function (dot) {
				var dotPanelNumber = parseInt(dot.getAttribute("data-panel-target"), 10);
				var isComplete = !isNaN(activePanelNumber)
					&& !isNaN(dotPanelNumber)
					&& dotPanelNumber < activePanelNumber;

				dot.classList.toggle("is-complete", isComplete);
			});
		}

		function setActiveImageBySuffix(suffix) {
			var img = document.getElementById("image-" + suffix);

			clearActiveImages();
			if (img) img.classList.add("active");
		}

		function setCtaNavState(isPanel5Active) {

			if (ctaEl) {
				ctaEl.classList.toggle("active", isPanel5Active);
			}

			navEls.forEach(function (navEl) {
				navEl.classList.toggle("not-active", isPanel5Active);
			});

			if (mobileNavWrapper) {
				mobileNavWrapper.classList.toggle("not-active", isPanel5Active);
			}
		}

		function chooseActivePanel() {
			var centerY = window.innerHeight / 2;
			var bestPanel = null;
			var bestDist = Infinity;

			for (var i = 0; i < panels.length; i++) {
				var rect = panels[i].getBoundingClientRect();

				if (rect.bottom <= 0 || rect.top >= window.innerHeight) continue;

				if (rect.top <= centerY && rect.bottom >= centerY) {
					return panels[i];
				}

				var panelCenter = rect.top + rect.height / 2;
				var dist = Math.abs(panelCenter - centerY);

				if (dist < bestDist) {
					bestDist = dist;
					bestPanel = panels[i];
				}
			}

			return bestPanel;
		}

		function updateUIForActivePanel(activePanel) {
			if (!activePanel) {
				clearActiveDots();
				clearCompletedDots();
				clearActiveImages();
				setCtaNavState(false);
				return;
			}

			var suffix = activePanel.id.replace("panel-", "");
			var hasMatchingDot = dots.some(function (dot) {
				return dot.getAttribute("data-panel-target") === suffix;
			});

			setCtaNavState(activePanel.id === "panel-5");
			setCompletedDotsBeforeSuffix(suffix);

			if (hasMatchingDot) {
				setActiveDotsBySuffix(suffix);
				setActiveImageBySuffix(suffix);
			} else {
				clearActiveDots();
				clearActiveImages();
			}
		}

		function updateActiveState() {
			updateUIForActivePanel(chooseActivePanel());
		}

		function updateNavProgress() {
			var centerY = window.innerHeight / 2;

			navEls.forEach(function (navEl) {
				var progressDots = Array.prototype.slice.call(
					navEl.querySelectorAll('.graphic-panel__nav-dot[data-panel-target][data-progress]')
				);
				var stops = [];

				progressDots.forEach(function (dot) {
					var panel = document.getElementById("panel-" + dot.getAttribute("data-panel-target"));
					var progress = parseFloat(dot.getAttribute("data-progress"));

					if (panel && !isNaN(progress)) {
						stops.push({
							top: panel.getBoundingClientRect().top,
							progress: progress
						});
					}
				});

				if (!stops.length) return;

				var progress = stops[0].progress;

				if (centerY >= stops[stops.length - 1].top) {
					progress = stops[stops.length - 1].progress;
				} else {
					for (var i = 0; i < stops.length - 1; i++) {
						var currentStop = stops[i];
						var nextStop = stops[i + 1];

						if (centerY < currentStop.top || centerY >= nextStop.top) continue;

						var stopDistance = nextStop.top - currentStop.top;
						var sectionProgress = stopDistance > 0
							? (centerY - currentStop.top) / stopDistance
							: 0;

						progress = currentStop.progress
							+ ((nextStop.progress - currentStop.progress) * sectionProgress);
						break;
					}
				}

				progress = Math.max(0, Math.min(100, progress));
				navEl.style.setProperty("--graphic-panel-progress", progress + "%");
			});
		}

		var updateFrame = null;

		function requestUIUpdate() {
			if (updateFrame !== null) return;

			updateFrame = window.requestAnimationFrame(function () {
				updateActiveState();
				updateNavProgress();
				updateFrame = null;
			});
		}

		var io = new IntersectionObserver(function () {
			requestUIUpdate();
		}, {
			root: null,
			rootMargin: "-10% 0px -10% 0px",
			threshold: [0, 0.01, 0.1, 0.25, 0.5, 0.75, 1]
		});

		panels.forEach(function (panel) {
			io.observe(panel);
		});

		window.addEventListener("scroll", requestUIUpdate, { passive: true });
		window.addEventListener("resize", requestUIUpdate);

		requestUIUpdate();
		setTimeout(requestUIUpdate, 250);
	})();
});
